module.exports = __webpack_public_path__ + "media/images/certification/unchecked-e07e5da185b00e75ed5b3ffa3001ae63.svg";